module.exports = __webpack_public_path__ + "static/dockington-insiders-8c550a8226aeca4a6b1e23ac5d3fc892.jpg";